export default "__VITE_ASSET__DEWPlHnK__"